import { TABLET_MAX_WIDTH } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { CSSProperties, FC } from 'react';
type Props = {
  style?: CSSProperties;
  children: React.ReactNode;
};
const PageContainer: FC<Props> = ({
  style,
  children
}) => <Container style={style}>{children}</Container>;
export default PageContainer;
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1nu7spg"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");